<template>
  <div class="c-input">
    <label :for="uniqueId" class="c-input__label" v-if="label">{{ label }} <a href="#" class="c-tooltip-trigger" v-if="tooltip">?<span class="c-tooltip">{{ tooltip }}</span></a></label>
    <div class="c-input__controls">
      <slot :unique-id="uniqueId"/>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String
    },
    tooltip: {
      type: String
    }
  },
  computed: {
    uniqueId () {
      return '_' + Math.random().toString(36).substr(2, 9)
    }
  }
}
</script>

<style lang="scss">
@import '../assets/styles/variables.scss';

.c-input {
  display: block;
  margin-bottom: 2.4rem;
}

.c-input__label {
  display: block;
  font-size: 1.7rem;
  font-weight: 600;
  line-height: 2.4rem;
  margin-bottom: 1.6rem;
}

.c-input__controls {
  input[type="text"],
  input[type="email"],
  input[type="number"],
  textarea {
    -moz-appearance: none;
    -webkit-appearance: none;
    background: rgba(#FFF, 0.15);
    border: 0;
    border-radius: 0;
    color: inherit;
    display: block;
    font: inherit;
    outline: 0;
    padding: 1.2rem 1.6rem;
    transition: all 0.15s linear;
    width: 100%;

    &:focus {
      background-color: rgba(#FFF, 0.25);
      box-shadow: inset 0 -1px 0 #FFF;
    }
  }

  select {
    -moz-appearance: none;
    -webkit-appearance: none;
    background: rgba(#FFF, 0.2) url('../assets/images/caret-down.svg') no-repeat right 1.6rem center;
    border: 0;
    border-radius: 0;
    color: inherit;
    display: block;
    font: inherit;
    outline: 0;
    padding: 1.2rem 1.6rem;
    transition: all 0.15s linear;
    width: 100%;

    &:focus {
      background-color: rgba(#FFF, 0.25);
      box-shadow: inset 0 -1px 0 #FFF;
    }
  }

  option {
    color: $black;
  }
}

a.c-tooltip-trigger {
  align-items: center;
  background-color: rgba(#FFF, 0.3);
  border-radius: 50%;
  color: $black;
  cursor: pointer;
  display: inline-flex;
  height: 2.4rem;
  justify-content: center;
  margin: -0.4rem 0 -0.4rem 0.8rem;
  position: relative;
  text-align: center;
  transition: all 0.15s ease-in-out;
  width: 2.4rem;

  &:hover,
  &:focus {
    background-color: rgba(#FFF, 0.6);
    color: #FFF;
  }
}

.c-tooltip {
  background: $blue;
  bottom: calc(100% + 2.4rem);
  box-shadow: 0 2.4rem 4.8rem rgba($black, 0.5);
  color: #FFF;
  font-size: 1.4rem;
  font-weight: normal;
  line-height: 1.5;
  opacity: 0;
  padding: 1.6rem;
  pointer-events: none;
  position: absolute;
  text-align: left;
  transform: translateY(2.4rem);
  transition: all 0.2s ease-in-out;
  width: 28rem;
  z-index: 5;

  &:before {
    background: inherit;
    bottom: -0.8rem;
    content: '';
    height: 1.6rem;
    left: 50%;
    position: absolute;
    transform: translateX(-50%) rotate(-45deg);
    transform-origin: 50% 50%;
    width: 1.6rem;
  }
}

.c-tooltip-trigger:hover,
.c-tooltip-trigger:focus {
  .c-tooltip {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
